export function mod(n: number, m: number): number {
  return ((n % m) + m) % m;
}

import { EXTENT } from "../constants";

/**
 * Projects a point within a tile to the surface of the unit sphere globe.
 * @param inTileX - X coordinate inside the tile in range [0 .. 8192].
 * @param inTileY - Y coordinate inside the tile in range [0 .. 8192].
 * @param tileIdX - Tile's X coordinate in range [0 .. 2^zoom - 1].
 * @param tileIdY - Tile's Y coordinate in range [0 .. 2^zoom - 1].
 * @param tileIdZ - Tile's zoom.
 * @returns A 3D vector - coordinates of the projected point on a unit sphere.
 */
function projectTileCoordinatesToSphere(
  inTileX: number,
  inTileY: number,
  tileIdX: number,
  tileIdY: number,
  tileIdZ: number,
): [number, number, number] {
  // This code could be assembled from 3 fuctions, but this is a hot path for symbol placement,
  // so for optimization purposes everything is inlined by hand.
  //
  // Non-inlined variant of this function would be this:
  //     const mercator = tileCoordinatesToMercatorCoordinates(inTileX, inTileY, tileID);
  //     const angular = mercatorCoordinatesToAngularCoordinatesRadians(mercator.x, mercator.y);
  //     const sphere = angularCoordinatesRadiansToVector(angular[0], angular[1]);
  //     return sphere;
  const scale = 1.0 / (1 << tileIdZ);
  const mercatorX = (inTileX / EXTENT) * scale + tileIdX * scale;
  const mercatorY = (inTileY / EXTENT) * scale + tileIdY * scale;
  const sphericalX = mod(mercatorX * Math.PI * 2.0 + Math.PI, Math.PI * 2);
  const sphericalY = 2.0 * Math.atan(Math.exp(Math.PI - mercatorY * Math.PI * 2.0)) - Math.PI * 0.5;
  const len = Math.cos(sphericalY);
  const vec = new Float64Array(3) as any;
  vec[0] = Math.sin(sphericalX) * len;
  vec[1] = Math.sin(sphericalY);
  vec[2] = Math.cos(sphericalX) * len;

  return vec;
}

export { projectTileCoordinatesToSphere };
